import { Center, Loader } from '@mantine/core';
import { brand } from '../theme/theme';

/** Full-viewport centred loader shown while a route or its data is pending. */
export function PageLoader() {
  return (
    <Center role="status" h="100vh" bg={brand.bg}>
      <Loader color="forest" />
    </Center>
  );
}
